// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"272e3186","374":"7f1e854b","446":"5bdf6d89","494":"43733c7b","547":"d61082f1"}[chunkId] + ".chunk.js";
};